import { TResApi, TResApiErr, TResDataListApi } from '@src/configs/interface.config'
import { checkAuth } from '@src/libs/localStorage'
import { TReward } from '@src/modules/reward'
import { useMutation, useQuery } from 'react-query'
import { notification } from 'antd'
import { NSuccess } from '@src/configs/const.config'
import { TQueryRewardUser, TRewardUser } from '@src/modules/reward-user'
import { getLisRewardUser, getRewardUserById, removeRewardUserById, removeRewardUserByIds } from '@queries/apis'
import { DETAIL_REWARD_USER, LIST_REWARD_USER } from '@queries/keys'

import { queryClient } from '..'

export const useQueryListRewardUser = (params: TQueryRewardUser, token?: string) => {
  const accessToken = token || checkAuth()
  return useQuery<TResDataListApi<TRewardUser[]>>(
    [LIST_REWARD_USER, JSON.stringify(params)],
    () => getLisRewardUser(params, accessToken),
    {
      enabled: !!accessToken,
    },
  )
}

export const useMutationRemoveRewardUserById = () =>
  useMutation(removeRewardUserById, {
    onSuccess: (res: TResApi, id) => {
      queryClient.refetchQueries([LIST_REWARD_USER]).then()
      queryClient.removeQueries([DETAIL_REWARD_USER, id])
      notification.success({ message: NSuccess, description: res?.message })
    },
  })

export const useMutationRemoveRewardUserByIds = () =>
  useMutation<TResApi, TResApiErr, { ids: string[] }>(removeRewardUserByIds, {
    onSuccess: (res: TResApi, { ids }) => {
      queryClient.refetchQueries([LIST_REWARD_USER]).then()
      ids.forEach((id) => queryClient.removeQueries([DETAIL_REWARD_USER, id]))
      notification.success({ message: NSuccess, description: res?.message })
    },
  })

export const useQueryRewardUserById = (id: string, token?: string) => {
  const accessToken = token || checkAuth()
  return useQuery<TResApi<TReward>>([DETAIL_REWARD_USER, id], () => getRewardUserById(id, accessToken), {
    enabled: !!accessToken && !!id,
  })
}
